export const FILTER_OPERATORS = {
    CONTAINS_IGNORE_CASE: 'containsIgnoreCase'
};